<style lang="scss" scoped>
.actions {
	margin-left: auto !important;
}
</style>
<template lang="pug">
div
	app-header(v-if="!isOrg")
		template(slot='header')
			.d-flex
				h1 Calendary sync
				el-button(type='primary', :loading='loading', @click='save', e2e="settings").actions {{ loading ? "Saving settings..." : "Save settings" }}
	calendar-form(ref="calendar_form" v-on:Saving="loading = $event")
</template>
<script>
import CalendarForm from "./CalendarForm";
export default {
	components: {
		CalendarForm
	},
	data() {
		return {
			loading: false
		};
	},
	props: {
		isOrg: Boolean,
	},
	methods: {
		save() {
			this.$refs.calendar_form.save();
		}
	}
};
</script>